import { apiRequest } from "../../Timetable/utils/http.js";

// Hours and overtime. All three endpoints are ADMIN or SUPERVISOR: an admin
// sees everyone (the paymaster view), a supervisor exactly the people on
// their supervision list, which the admin screen maintains.

/** The review queue over [from, to]; status and campus narrow it. */
export async function listOvertimeForReview({ from, to, status, campus }) {
  const params = new URLSearchParams({ from, to });
  if (status) params.set("status", status);
  if (campus) params.set("campus", campus);
  const rows = await apiRequest(`api/overtime?${params.toString()}`);
  return Array.isArray(rows) ? rows : [];
}

/** Approve or reject one entry. The decision is final; reviewing your own is refused. */
export async function reviewOvertime(id, status, note) {
  return apiRequest(`api/overtime/${id}/review`, {
    method: "PUT",
    body: { status, note: note || null },
  });
}

/**
 * Every campus, not only the ones running now. The hours report is often
 * asked about a season that has finished, and it takes a campus name rather
 * than an id, so what matters is the distinct set of names.
 */
export async function listAllCampuses() {
  const rows = await apiRequest("api/campuses");
  return Array.isArray(rows) ? rows : [];
}

/** One row per person per day on site, teaching split out from the rest. */
export async function getStaffHours({ campus, from, to }) {
  const params = new URLSearchParams({ campus, from, to });
  const rows = await apiRequest(`api/staffhours?${params.toString()}`);
  return Array.isArray(rows) ? rows : [];
}
